/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gradelevel_Graduated10Inputs */

const en__field__enum_gradelevel_graduated10 = /** @type {(inputs: _Field__Enum_Gradelevel_Graduated10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already graduated`)
};

const de__field__enum_gradelevel_graduated10 = /** @type {(inputs: _Field__Enum_Gradelevel_Graduated10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schule bereits abgeschlossen`)
};

/**
* | output |
* | --- |
* | "Already graduated" |
*
* @param {_Field__Enum_Gradelevel_Graduated10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gradelevel_graduated10 = /** @type {((inputs?: _Field__Enum_Gradelevel_Graduated10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gradelevel_Graduated10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gradelevel_graduated10(inputs)
	return de__field__enum_gradelevel_graduated10(inputs)
});
export { _field__enum_gradelevel_graduated10 as "_field__enum_gradeLevel_GRADUATED" }